import { Component } from '@angular/core';

const sessionStorageKey = 'MOVE_BROWSER_SUPPORT_BANNER';
const sessionStorageTrueVal = 'closed';

@Component({
  selector: 'mmu-browser-support-banner',
  template: `
    <mui-banner
      *ngIf="!bannerHasBeenClosed && isUnsupportedBrowser"
      class="mui-app-frame__banner banner--unsupported-browser"
      color="info"
      icon="browser">
      <span [innerHTML]="'unsupportedBrowserBanner.message' | translate"></span>
      <a [innerText]="'unsupportedBrowserBanner.closeBtn' | translate" (click)="dismiss()" class="banner-close-btn"></a>
    </mui-banner>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .banner--unsupported-browser ::ng-deep a {
        color: inherit;
        cursor: pointer;
        font-weight: 500;
        text-decoration: underline;
      }

      .banner-close-btn {
        margin-left: 1rem;
      }
    `
  ]
})
export class MmuBrowserSupportBanner {
  static readonly sessionStorageKey = sessionStorageKey;

  readonly isUnsupportedBrowser: boolean;
  bannerHasBeenClosed = false;

  constructor() {
    this.isUnsupportedBrowser = MmuBrowserSupportBanner.isInternetExplorer();
    this.bannerHasBeenClosed = sessionStorage.getItem(MmuBrowserSupportBanner.sessionStorageKey) === sessionStorageTrueVal;
  }

  static isInternetExplorer(): boolean {
    const ieRegex = new RegExp(/Trident\/|MSIE/);
    return ieRegex.test(navigator.userAgent);
  }

  dismiss(): void {
    sessionStorage.setItem(MmuBrowserSupportBanner.sessionStorageKey, sessionStorageTrueVal);
    this.bannerHasBeenClosed = true;
  }
}
